import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';


// only initialize when in the browser
if (typeof window !== 'undefined') {
  LogRocket.init('pwd29e/ciduapp'); 
  setupLogRocketReact(LogRocket);
}